import React, { useEffect, useRef, useState } from 'react';
import { Col, ControlLabel, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { FormError } from '../../../FormError.jsx';
import RatingField from '../RatingField.jsx';
import { UploadIcon } from '../../../icons/UploadIcon.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../../headers/FormHeaders/MultistepFormsNav.jsx';

function StepGeneralForm(props) {
  const {
    handleSubmit,
    submitFailed,
    submitError,
    onCancel,
    fields,
    handleImageSelect,
    clearImageField,
    errors,
    loading,
    values,
  } = props;

  const [fileName, setFileName] = useState('');

  const inputRef = useRef();
  const file = inputRef.current ? inputRef.current.files[0] : null;

  const { impact } = fields;

  useEffect(() => {
    if (file) {
      setFileName(file.name);
    }
  }, [file]);

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <MultistepFormsNav
            type="changeStrategy"
            activeIndex={0}
            onSubmit={handleSubmit}
          />
        </Col>
        <Col xs={5}>
          <FormGroup className="flex flex-col flex-align-start">
            <ControlLabel>Upload</ControlLabel>
            <div className="m-b-8 w-100">
              <label htmlFor="avatar" className="file-input">
                <UploadIcon />
                <span className="m-l-4">Upload</span>
                <input
                  style={{ display: 'none' }}
                  ref={inputRef}
                  id="avatar"
                  type="file"
                  accept=".jpeg, .png, .jpg"
                  onChange={handleImageSelect}
                />
              </label>
              <div className="file-name m-t-8">{fileName}</div>
            </div>
            {submitFailed && errors.avatar && (
              <FormGroup validationState="error m-0">
                <HelpBlock>{errors.avatar}</HelpBlock>
              </FormGroup>
            )}
            <p className="m-0 text-muted">Allowed formats: .jpeg, .png, .jpg</p>
            <p className="text-muted">Max file size: 10Mb</p>
          </FormGroup>
        </Col>
        {fileName ? (
          <Col xs={1}>
            <button
              type="button"
              className="btn-delete btn btn-default m-t-28"
              onClick={() => {
                clearImageField();
                setFileName('');
              }}
            ></button>
          </Col>
        ) : null}
      </Row>

      <Row>
        <Col sm={4}>
          <RatingField label={impact.name} name={impact.key} />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
        </Col>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepGeneralForm;
